import React, { useEffect, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import apiUrl from "../Apiurl";
import LinkArticolo from "../modificaProdotti/schedaArticolo/LinkArticolo";
import { BlockSkeleton } from "../interfaccia/loading";

const data = (value) => value ? new Date(value).toLocaleString("it-IT") : "—";
const STATI = {
  DONE: "Completato", SUCCESS: "Riuscito", ERROR: "Errore", REVIEW: "Da rivedere", WAITING: "In attesa",
  PENDING: "In coda", IN_PROGRESS: "In lavorazione", SCHEDULED: "Accodato", SKIPPED: "Saltato", REJECTED: "Rifiutato",
  NO_SOURCE: "Nessuna immagine sorgente", TARGET_NOT_EMPTY: "Destinazione già valorizzata",
  DOMINO_NOT_EMPTY: "Immagini già presenti in Domino", INELIGIBLE: "Non eleggibile",
};
const ETICHETTE = {
  missing: "Minimi mancanti", optional: "Da rivedere", issues: "Segnalazioni", imageIssue: "Problema immagini",
  contentIssue: "Problema contenuti", error: "Errore", reason: "Motivo", recovery: "Recupero BOT", imported: "Campi importati",
  vigSyncQueued: "Invio a VIG gestito", syncNote: "Invio testi", syncIssue: "Problema invio testi",
  runId: "Run", itemId: "Item", jobImmagini: "Job immagini", prossimoControllo: "Prossimo controllo",
  statoJob: "Stato job", ultimoPasso: "Ultimo passo", immaginiSorgente: "Immagini sorgente", fileTotali: "File totali",
  fileElaborati: "File elaborati", tentativi: "Tentativi", ultimoControllo: "Ultimo controllo", jobId: "Job",
  richiestoDa: "Richiesto da", modificato: "Prodotto modificato", dashboardAccodata: "Invio accodato", elaboratoIl: "Elaborato il",
};
const DATE = new Set(["prossimoControllo", "ultimoControllo", "elaboratoIl"]);
function formato(value) {
  if (typeof value === "boolean") return value ? "Sì" : "No";
  if (Array.isArray(value)) return value.map(formato).join(", ");
  return typeof value === "object" ? JSON.stringify(value) : String(value);
}

function Dettagli({ riga }) {
  const dettagli = Object.entries(riga.dettagli || {}).filter(([, value]) => value !== null && value !== undefined && value !== "" &&
    (!Array.isArray(value) || value.length > 0) && value !== riga.messaggio);
  return <>
    {riga.messaggio && <p className="mt0 mb2">{riga.messaggio}</p>}
    {dettagli.length > 0 && <dl className="backfill-activity-details ma0">{dettagli.map(([key, value]) => <React.Fragment key={key}>
      <dt>{ETICHETTE[key] || key}</dt><dd className="ma0">{DATE.has(key) ? data(value) : formato(value)}</dd>
    </React.Fragment>)}</dl>}
    {!riga.messaggio && !dettagli.length && "—"}
  </>;
}

export default function AttivitaBackfill({ refresh, aperta }) {
  const { getAccessTokenSilently } = useAuth0();
  const contenitore = useRef(null);
  const [visibile, setVisibile] = useState(false);
  const [risultato, setRisultato] = useState(null);
  const [errore, setErrore] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") { setVisibile(true); return undefined; }
    const observer = new IntersectionObserver(([entry]) => setVisibile(entry.isIntersecting), { rootMargin: "200px" });
    observer.observe(contenitore.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!visibile || aperta) return undefined;
    const controller = new AbortController();
    setLoading(true);
    async function carica() {
      try {
        const token = await getAccessTokenSilently();
        if (controller.signal.aborted) return;
        const response = await axios.get(`${apiUrl}/moda/backfill/attivita`, {
          headers: { Authorization: `Bearer ${token}` }, signal: controller.signal,
        });
        if (controller.signal.aborted) return;
        if (!response.data?.success || !Array.isArray(response.data.data?.processi)) throw new Error("Risposta attività non valida.");
        setRisultato(response.data.data);
        setErrore("");
      } catch (err) {
        if (!controller.signal.aborted) setErrore(err?.response?.status === 404 ? "Attività non disponibili con questa versione dell'API."
          : err?.response?.data?.error || err?.message || "Lettura attività non riuscita.");
      } finally { if (!controller.signal.aborted) setLoading(false); }
    }
    carica();
    return () => controller.abort();
  }, [visibile, aperta, refresh, getAccessTokenSilently]);

  return <section ref={contenitore} className="traduzioni-card sfondoBiancoTema ba bordoColAlt br3 pa3 mt3" aria-label="Attività recenti per articolo">
    <h2 className="mt0">Attività recenti per articolo</h2>
    <p className="f6">Ultime 20 registrazioni disponibili per ciascun processo.
      Per allineamenti, recupero e immagini è conservato solo l’ultimo stato per articolo;
      per traduzioni e verifiche sono mostrate le lavorazioni dei job, manuali e automatici.</p>
    {risultato && <p className="f7">Dati letti il {data(risultato.generatoIl)}{loading ? " · aggiornamento in corso" : ""}.</p>}
    {errore && <p role="alert">{errore}{risultato ? " Restano visibili i dati della lettura precedente." : ""}</p>}
    {loading && !risultato && <BlockSkeleton height={220} />}
    {(risultato?.processi || []).map((processo) => <section key={processo.chiave} className="mt4" aria-label={`Attività ${processo.titolo}`}>
      <h3 className="f5 mb2">{processo.titolo}</h3>
      <p className="f7 mt0">{processo.registro === "checkpoint" ? "Ultimi aggiornamenti dei checkpoint; i passaggi precedenti non sono conservati."
        : "Ultimo stato degli articoli nei job; lo stesso articolo può comparire in job diversi."}</p>
      {processo.errore ? <p role="alert">Lettura non riuscita: {processo.errore}</p> : !processo.dati?.length
        ? <p className="f6">Nessuna attività registrata.</p> : <div className="traduzioni-table-scroll backfill-activity-scroll" tabIndex={0} aria-label={`Elenco attività ${processo.titolo}`}>
          <table className="traduzioni-articles f6"><caption className="clip">Ultime attività {processo.titolo}</caption>
            <thead><tr><th scope="col">Data e ora</th><th scope="col">Articolo</th><th scope="col">Esito</th><th scope="col">Dettagli</th></tr></thead>
            <tbody>{processo.dati.map((riga) => <tr key={riga.id}>
              <td className="nowrap">{data(riga.il)}</td>
              <td><LinkArticolo codVS={riga.codVS} title={data(riga.il)} /></td>
              <td><span className={`backfill-esito b ${["DONE", "SUCCESS"].includes(riga.stato) ? "scrittaVerde" : ["ERROR", "REJECTED"].includes(riga.stato) ? "scrittaRosso" : ""}`}>{STATI[riga.stato] || riga.stato}</span>
                <div className="f7 mt1">{riga.stato}</div></td>
              <td className="backfill-activity-text"><Dettagli riga={riga} /></td>
            </tr>)}</tbody>
          </table>
        </div>}
    </section>)}
  </section>;
}
